/* tslint:disable */
/* eslint-disable */
/**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import {
    AttachmentRedirectUrlsFromJSON,
    AttachmentRedirectUrlsToJSON,
} from './AttachmentRedirectUrls';
/**
 * @export
 */
export const AttachmentOriginEnum = {
    EmailAttachment: 'EmailAttachment',
    BdpTool: 'BdpTool',
    PcTool: 'PcTool',
    AgentUpload: 'AgentUpload',
    FormHandler: 'FormHandler',
    BusinessPortal: 'BusinessPortal',
};
/**
 * @export
 */
export const AttachmentCategoryEnum = {
    DiagnosticReport: 'DiagnosticReport',
    InvoiceDocument: 'InvoiceDocument',
    ShippingDocument: 'ShippingDocument',
    Letter: 'Letter',
    PictureReference: 'PictureReference',
    BugReport: 'BugReport',
    Other: 'Other',
    Unclassified: 'Unclassified',
    ServiceForms: 'ServiceForms',
    RegistrationDocument: 'RegistrationDocument',
    ShopInside: 'ShopInside',
    ShopImageMigration: 'ShopImageMigration',
    ShopImage: 'ShopImage',
};
/**
 * Check if a given object implements the Attachment interface.
 */
export function instanceOfAttachment(value) {
    let isInstance = true;
    return isInstance;
}
export function AttachmentFromJSON(json) {
    return AttachmentFromJSONTyped(json, false);
}
export function AttachmentFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        attachmentId: !exists(json, 'attachmentId')
            ? undefined
            : json['attachmentId'],
        bucket: !exists(json, 'bucket') ? undefined : json['bucket'],
        objectKey: !exists(json, 'objectKey') ? undefined : json['objectKey'],
        transactionId: !exists(json, 'transactionId')
            ? undefined
            : json['transactionId'],
        referenceId: !exists(json, 'referenceId')
            ? undefined
            : json['referenceId'],
        origin: !exists(json, 'origin') ? undefined : json['origin'],
        category: !exists(json, 'category') ? undefined : json['category'],
        fileName: !exists(json, 'fileName') ? undefined : json['fileName'],
        fileExtension: !exists(json, 'fileExtension')
            ? undefined
            : json['fileExtension'],
        mimeType: !exists(json, 'mimeType') ? undefined : json['mimeType'],
        createdAt: !exists(json, 'createdAt') ? undefined : json['createdAt'],
        uploadUrl: !exists(json, 'uploadUrl') ? undefined : json['uploadUrl'],
        uploadUrlExpiration: !exists(json, 'uploadUrlExpiration')
            ? undefined
            : json['uploadUrlExpiration'],
        downloadUrl: !exists(json, 'downloadUrl')
            ? undefined
            : json['downloadUrl'],
        downloadUrlExpiration: !exists(json, 'downloadUrlExpiration')
            ? undefined
            : json['downloadUrlExpiration'],
        redirectUrls: !exists(json, 'redirectUrls')
            ? undefined
            : AttachmentRedirectUrlsFromJSON(json['redirectUrls']),
    };
}
export function AttachmentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        attachmentId: value.attachmentId,
        bucket: value.bucket,
        objectKey: value.objectKey,
        transactionId: value.transactionId,
        referenceId: value.referenceId,
        origin: value.origin,
        category: value.category,
        fileName: value.fileName,
        fileExtension: value.fileExtension,
        mimeType: value.mimeType,
        createdAt: value.createdAt,
        uploadUrl: value.uploadUrl,
        uploadUrlExpiration: value.uploadUrlExpiration,
        downloadUrl: value.downloadUrl,
        downloadUrlExpiration: value.downloadUrlExpiration,
        redirectUrls: AttachmentRedirectUrlsToJSON(value.redirectUrls),
    };
}
